import { updateProductGroup } from './apiUpdateProductGroup';
import { useMutation } from '@tanstack/react-query';
import { useDispatch } from 'react-redux';
import { globalError } from '../../store/notifications/actions';
import { invalidateLibraryManagedProductGroupFeaturedPages } from '../../yourborrowbox/marketing/productgroups/api/useLibraryManagedProductGroupsFeaturePages';

export const useUpdateProductGroup = () => {
    const dispatch = useDispatch();

    return useMutation(updateProductGroup, {
        onSuccess: () => {
            invalidateLibraryManagedProductGroupFeaturedPages().then();
        },
        onError: (error: any) => dispatch(globalError(error))
    });
};
